/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMetaMcpServerUsagePayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * The gateway (meta MCP server) ID
   */
  metaMcpServerId: string;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export type GetMetaMcpServerUsagePayload$Outbound = {
  from: string;
  meta_mcp_server_id: string;
  to: string;
};

/** @internal */
export const GetMetaMcpServerUsagePayload$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsagePayload$Outbound,
  GetMetaMcpServerUsagePayload
> = z.pipe(
  z.object({
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    metaMcpServerId: z.string(),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      metaMcpServerId: "meta_mcp_server_id",
    });
  }),
);

export function getMetaMcpServerUsagePayloadToJSON(
  getMetaMcpServerUsagePayload: GetMetaMcpServerUsagePayload,
): string {
  return JSON.stringify(
    GetMetaMcpServerUsagePayload$outboundSchema.parse(
      getMetaMcpServerUsagePayload,
    ),
  );
}
